export function sortArticlesByUrlList<T extends { url: string }>(list: string[], articles: T[]): T[] {
	const articleMap = new Map<string, T>();
	articles.forEach(article => {
		articleMap.set(article.url, article);
	});

	return list.map(url => articleMap.get(url)).filter((item): item is T => Boolean(item));
}